import { useMemo } from 'react'

import {
  resourceListTag,
  useOpenWindow,
  useWindow,
  useDebouncedValue,
  useQueryResult,
} from '@krp/client-runtime'
import {
  EMPTY_LIST_FILTER,
  ONEC_SUPPLY_TAG,
  ONEC_SUPPLY_WINDOWS,
  SuppliesListScreen,
  listFilterChanged,
  listMoreRequested,
  makeSelectSuppliesListVm,
  normalizeRid,
  onecSupplies,
  suppliesApi,
  type SuppliesListActions,
  type SupplyListArgs,
} from '@krp/resource-onec-ui'

import { useAppDispatch, useAppSelector } from '../../app/hooks'

/** Binding списка поставок: rid — из окна; фильтр и число страниц — намерение этой базы. */
export function SuppliesBinding() {
  const window = useWindow()
  const dispatch = useAppDispatch()
  const openWindow = useOpenWindow()
  const resourceId = normalizeRid(window.params.rid ?? '')
  const filter = useAppSelector((state) => state.onec.supplies.listFilter[resourceId]) ?? EMPTY_LIST_FILTER
  const pages = useAppSelector((state) => state.onec.supplies.listPages[resourceId]) ?? 1
  const number = useDebouncedValue(filter.number)
  const args = useMemo<SupplyListArgs | null>(
    () => (resourceId === '' ? null : { resourceId, status: filter.status, number, pages }),
    [resourceId, filter.status, number, pages],
  )
  const list = useQueryResult(onecSupplies, args)
  const selectVm = useMemo(() => makeSelectSuppliesListVm(), [])
  const intent = useAppSelector((state) => state.onec.supplies)
  const vm = selectVm({ resourceId, list, intent })

  const actions = useMemo<SuppliesListActions>(
    () => ({
      filterChanged: (patch) => dispatch(listFilterChanged({ resourceId, patch })),
      loadMore: () => dispatch(listMoreRequested({ resourceId, pages: pages + 1 })),
      reload: () => dispatch(suppliesApi.util.invalidateTags([resourceListTag(ONEC_SUPPLY_TAG, resourceId)])),
      open: (supplyId) => openWindow(ONEC_SUPPLY_WINDOWS.supply, { rid: resourceId, supplyId }),
      create: () => openWindow(ONEC_SUPPLY_WINDOWS.create, { rid: resourceId }),
      openReceipts: () => openWindow(ONEC_SUPPLY_WINDOWS.receipts, { rid: resourceId }),
    }),
    [dispatch, openWindow, pages, resourceId],
  )
  return <SuppliesListScreen vm={vm} actions={actions} />
}
